<template>
  <nav
    class="bg-background-neutral-blur-secondary fixed bottom-0 left-0 right-0 z-50 flex h-20 flex-col backdrop-blur-lg"
  >
    <div class="flex w-full items-start pt-[7px]">
      <BottomNavItem
        v-for="item in items"
        :key="item.key"
        :icon="item.icon"
        :label="item.label"
        :is-active="activeKey === item.key"
        @on-click="item.action?.()"
      />
    </div>
  </nav>
</template>

<script setup lang="ts">
  import type { Component } from 'vue';
  import BottomNavItem from './BottomNavItem.vue';

  export type BottomNavItemConfig = {
    key: string;
    icon: Component;
    label: string;
    action?: () => void;
  };

  defineProps<{
    items: BottomNavItemConfig[];
    activeKey: string;
  }>();
</script>
